import type { AlgebraKey } from './keys';

export const ro: Partial<Record<AlgebraKey, string>> = {
  'app.title': 'Algebră',
  'app.eyebrow': 'Matematică · Algebră',
  'app.tagline': 'Rezolvă, descompune, simplifică și rezolvă.',
  'app.panel.heading': 'Algebră',
  'panel.experiment': 'Experiment',
  'panel.enter-number': 'Introduceți o expresie sau ecuație',
  'panel.show-sigma-stack': 'Afișați stiva sumelor parțiale',
  'panel.show-closed-form': 'Afișați forma închisă',
  'panel.show-sign-chart': 'Afișează tabelul de semne',
  'label.system': 'Sistem',
  'label.solution': 'Soluție',
  'label.steps': 'Pași',
  'hint.line1': 'Alegeți un experiment, manipulați expresiile și urmăriți cum se schimbă algebra.',
  'hint.line2': 'Conținutul educativ trăiește în regulile algebrei, nu în text.',
  // 8 Experiments
  'experiment.equation-balance.label': 'Echilibrul ecuației',
  'experiment.equation-balance.info': 'Rezolvați ecuații prin echilibrarea ambelor părți',
  'experiment.factor-tiles.label': 'Plăci de factori',
  'experiment.factor-tiles.info': 'Descompuneți polinoame aranjând plăcile',
  'experiment.quadratic-workshop.label': 'Atelierul ecuațiilor de gradul doi',
  'experiment.quadratic-workshop.info':
    'Rezolvați ecuații de gradul doi în trei moduri: descompunere în factori, formarea pătratului perfect și formula cuadratică',
  'experiment.polynomial-arithmetic.label': 'Aritmetica polinoamelor',
  'experiment.polynomial-arithmetic.info': 'Înmulțiți și împărțiți polinoame',
  'experiment.systems-laboratory.label': 'Laboratorul sistemelor',
  'experiment.systems-laboratory.info': 'Rezolvați sisteme de ecuații liniare',
  'experiment.inequality-line.label': 'Linia inegalităților',
  'experiment.inequality-line.info': 'Rezolvați și vizualizați inegalități pe o linie numerică',
  'experiment.sequences-staircase.label': 'Scara progresiilor',
  'experiment.sequences-staircase.info': 'Explorați progresiile aritmetice și geometrice',
  'experiment.expression-rewriter.label': 'Rescriitorul de expresii',
  'experiment.expression-rewriter.info': 'Aplicați reguli algebrice pentru a simplifica expresiile',
  // Operations
  'op.add-both-sides': 'Adunați la ambele părți',
  'op.subtract-both-sides': 'Scadeți din ambele părți',
  'op.multiply-both': 'Înmulțiți ambele părți',
  'op.divide-both': 'Împărțiți ambele părți',
  'op.square-both': 'Ridicați la pătrat ambele părți',
  'op.cross-multiply': 'Înmulțiți în cruce',
  // Methods
  'method.factoring': 'Descompunere în factori',
  'method.completing-square': 'Formarea pătratului perfect',
  'method.quadratic-formula': 'Formula cuadratică',
  'method.substitution': 'Substituție',
  'method.elimination': 'Eliminare',
  'method.rational-root-theorem': 'Teorema rădăcinilor raționale',
  'method.special-products': 'Produse speciale',
  // Rewriter rules
  'rule.distribute': 'Distribuire',
  'rule.collect-like-terms': 'Colectarea termenilor asemenea',
  'rule.factor-common-monomial': 'Factorizare monomial comună',
  'rule.cancel-common-factor': 'Anulare factor comun',
  'rule.simplify-fraction': 'Simplificare fracție',
  'rule.flatten-add': 'Aplatizare adunare',
  'rule.flatten-mul': 'Aplatizare înmulțire',
  'rule.exponent-product': 'Produs de exponenți',
  'rule.exponent-power': 'Putere a puterii',
  'rule.exponent-quotient': 'Cât de exponenți',
  'rule.negative-exponent': 'Exponent negativ',
  'rule.zero-exponent': 'Exponent zero',
  'rule.log-product': 'Regula produsului logaritmului',
  'rule.log-power': 'Regula puterii logaritmului',
  'rule.log-quotient': 'Regula câtului logaritmului',
  'rule.change-of-base': 'Schimbarea bazei',
  'rule.radical-to-frac-exp': 'Radical la exponent fracționar',
  'rule.frac-exp-to-radical': 'Exponent fracționar la radical',
  'rule.rationalize-denominator': 'Racionalizarea numitorului',
  'rule.multiply-by-conjugate': 'Înmulțire cu conjugatul',
  // Solution kinds
  'kind.unique': 'Soluție unică',
  'kind.inconsistent': 'Incompatibil',
  'kind.dependent': 'Dependent',
  'kind.extraneous': 'Străin',
  'kind.consistent-unique': 'Compatibil și unic',
  'kind.no-real-roots': 'Fără rădăcini reale',
  'kind.complex-pair': 'Pereche de numere complexe',
  'systems.no-solution': 'Fără soluție (incompatibil)',
  'systems.infinitely-many': 'O infinitate de soluții (compatibil nedeterminat)',
  // Sequence classes
  'class.arithmetic': 'Aritmetică',
  'class.geometric': 'Geometrică',
  'class.recurrence': 'Recurență',
  'class.convergent': 'Convergentă',
  'class.divergent': 'Divergentă',
  'class.telescoping': 'Telescopică',
  // Steps
  'step.add': 'Adunare',
  'step.subtract': 'Scădere',
  'step.multiply': 'Înmulțire',
  'step.divide': 'Împărțire',
  'step.distribute': 'Distribuire',
  'step.collect-like-terms': 'Colectarea termenilor asemenea',
  'step.cross-multiply': 'Înmulțire în cruce',
  'step.square-both': 'Ridicare la pătrat a ambelor părți',
  'step.factor': 'Factorizare',
  'step.quadratic-formula': 'Aplicarea formulei cuadratice',
  'step.isolate-variable': 'Izolarea variabilei',
  'step.extraneous-root-removed': 'Rădăcină străină eliminată',
  'step.factor-gcd': 'Factorizare CMMDC',
  'step.factor-rational-root': 'Factorizare folosind rădăcina rațională',
  'step.factor-grouping': 'Factorizare prin grupare',
  'step.factor-difference-of-squares': 'Factorizare ca diferență de pătrate',
  'step.factor-sum-of-cubes': 'Factorizare ca sumă de cuburi',
  'step.factor-difference-of-cubes': 'Factorizare ca diferență de cuburi',
  'step.factor-perfect-square': 'Factorizare ca pătrat perfect',
  'step.factor-special-product': 'Factorizare folosind produs special',
  'step.factor-quadratic-formula': 'Factorizare folosind formula cuadratică',
  'step.factor-irreducible': 'Ireductibil peste numerele raționale',
  'step.system-substitute': 'Substituire',
  'step.system-row-swap': 'Interschimbare de rânduri',
  'step.system-row-scale': 'Scalare rând',
  'step.system-row-add': 'Adunare rând la rând',
  'step.inequality-move-to-one-side': 'Mutare pe o parte',
  'step.inequality-factor': 'Factorizare',
  'step.inequality-critical-points': 'Găsire puncte critice',
  'step.inequality-asymptotes': 'Găsire asimptote',
  'step.inequality-sign-chart': 'Construire tabel de semne',
  'step.inequality-read-intervals': 'Citire intervale de soluție',
  // Buttons
  'btn.reset': 'Resetare',
  'btn.reset-view': 'Resetează vizualizarea',
  'btn.randomise': 'Aleatoriu',
  'btn.advanced': 'Avansat',
  'btn.auto-arrange': 'Aranjare automată',
  'btn.check-equivalent': 'Verificare echivalență',
  'btn.undo': 'Anulare',
  'btn.swap': 'Schimbă P ↔ Q',
  // Messages
  'message.parse-error.unexpected-token': 'Token neașteptat',
  'message.parse-error.unknown-variable': 'Variabilă necunoscută',
  'message.parse-error.not-a-polynomial': 'Nu este polinom',
  'message.no-real-solutions': 'Fără soluții reale',
  'message.extraneous-root-removed': 'Rădăcină străină eliminată',
  'message.dividing-by-zero-blocked': 'Nu se poate împărți la zero',
  'message.target-form-reached': 'Forma țintă atinsă',
  // Equation balance
  'balance.solved': 'Rezolvat!',
  'balance.not-tileable':
    'Plăcile necesită coeficienți întregi mici — editați ecuația sau randomizați.',
  // Factor tiles headline
  'factor.irreducible': 'ireductibil peste ℚ',
  'special.difference-of-squares': 'Produs special: diferență de pătrate',
  'special.perfect-square': 'Produs special: pătrat perfect',
  'special.sum-of-cubes': 'Produs special: sumă de cuburi',
  'special.difference-of-cubes': 'Produs special: diferență de cuburi',
};
